import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnchorComponent } from '../anchor/anchor.component';

@Component({
    selector: 'finder-switch-button',
    templateUrl: './switch-button.component.html',
    styleUrls: ['./switch-button.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        AnchorComponent,
    ]
})
export class SwitchButtonComponent {

    @Input() links: any;
    @Input() selected: string;
    @Output() viewChanged = new EventEmitter<boolean>();

    constructor() { }

    setSelected(id) {
        if (this.selected === id) {
            return;
        }
        this.selected = id;
        this.viewChanged.emit(id);
    }

    isSelected(id) {
        return this.selected === id;
    }
}
